import { render, staticRenderFns } from "./ImportLogsTable.vue?vue&type=template&id=041e7992"
import script from "./ImportLogsTable.vue?vue&type=script&lang=js"
export * from "./ImportLogsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports